import React from "react";

/*
 * Formatação do WhatsApp para a prévia: *negrito*, _itálico_, ~tachado~,
 * ```mono``` e variáveis {{x}} sem exemplo destacadas. Uma linha por vez
 * (quebras viram <br>). Sem aninhamento — suficiente para a prévia.
 */
const TOKEN_RE =
  /(\{\{\s*[A-Za-z0-9_]+\s*\}\}|```[^`]+```|\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)/g;

export function formatWhatsapp(text, variableClassName) {
  const out = [];
  String(text || "")
    .split("\n")
    .forEach((line, li) => {
      if (li > 0) out.push(<br key={`br-${li}`} />);
      line.split(TOKEN_RE).forEach((part, pi) => {
        if (!part) return;
        const key = `${li}-${pi}`;
        if (/^\{\{/.test(part)) {
          out.push(
            <span key={key} className={variableClassName}>
              {part}
            </span>
          );
        } else if (part.length > 6 && part.startsWith("```") && part.endsWith("```")) {
          out.push(<code key={key}>{part.slice(3, -3)}</code>);
        } else if (part.length > 2 && /^\*[^*]+\*$/.test(part)) {
          out.push(<strong key={key}>{part.slice(1, -1)}</strong>);
        } else if (part.length > 2 && /^_[^_]+_$/.test(part)) {
          out.push(<em key={key}>{part.slice(1, -1)}</em>);
        } else if (part.length > 2 && /^~[^~]+~$/.test(part)) {
          out.push(<s key={key}>{part.slice(1, -1)}</s>);
        } else {
          out.push(<React.Fragment key={key}>{part}</React.Fragment>);
        }
      });
    });
  return out;
}

export default formatWhatsapp;
